"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpsMetricsSchema = exports.ReportClientErrorSchema = exports.ErrorLogGroupSchema = exports.ErrorLogRowSchema = void 0;
const zod_1 = require("zod");
/** Quan sát vận hành — spec SC-16. */
exports.ErrorLogRowSchema = zod_1.z.object({
    id: zod_1.z.string(),
    /** Mã tra cứu — chính là mã hiện trên màn báo lỗi của giao diện */
    requestId: zod_1.z.string(),
    userId: zod_1.z.number().int().nullable(),
    path: zod_1.z.string(),
    message: zod_1.z.string(),
    stack: zod_1.z.string().nullable(),
    source: zod_1.z.enum(['api', 'admin']),
    createdAt: zod_1.z.coerce.date(),
});
/** Gom theo thông điệp: "lỗi gì, bao nhiêu lần, gần nhất lúc nào". */
exports.ErrorLogGroupSchema = zod_1.z.object({
    message: zod_1.z.string(),
    count: zod_1.z.number().int(),
    lastSeenAt: zod_1.z.coerce.date(),
});
/** Giao diện gặp lỗi làm sập React thì báo về đây (spec SC-16 §4). */
exports.ReportClientErrorSchema = zod_1.z.object({
    message: zod_1.z.string().min(1).max(2000),
    stack: zod_1.z.string().max(8000).optional(),
    path: zod_1.z.string().max(500),
});
/**
 * Số liệu vận hành — spec SC-16 §5.
 *
 * Đọc thẳng từ DB, KHÔNG dựng hệ thu thập số liệu riêng: ở quy mô một ứng dụng
 * nội bộ chạy trên một máy, Prometheus + Grafana nặng hơn hẳn thứ nó trả lời được.
 */
exports.OpsMetricsSchema = zod_1.z.object({
    /** Số lượt quét theo ngày, 30 ngày qua */
    scansByDay: zod_1.z.array(zod_1.z.object({ ngay: zod_1.z.string(), soLuot: zod_1.z.number().int() })),
    scanTotal: zod_1.z.number().int(),
    /** Thời gian máy chủ của trang đích phản hồi, ms */
    scanAvgMs: zod_1.z.number().int().nullable(),
    scanMaxMs: zod_1.z.number().int().nullable(),
    /** Tỉ lệ lượt quét lỗi, tính trên `ErrorLog` lọc theo đường /scan */
    scanErrorCount: zod_1.z.number().int(),
    pageCount: zod_1.z.number().int(),
    pageNeverScanned: zod_1.z.number().int(),
    /** Số trang bị nghi dựng bằng JavaScript ở lần quét gần nhất (spec SC-15) */
    pageRenderWarning: zod_1.z.number().int(),
    activeUsers7d: zod_1.z.number().int(),
    /** Cảnh báo sớm cho vấn đề phình dữ liệu ở spec SC-13 */
    dbSizeBytes: zod_1.z.number().int().nullable(),
    biggestTables: zod_1.z.array(zod_1.z.object({ ten: zod_1.z.string(), bytes: zod_1.z.number().int() })),
});
//# sourceMappingURL=observability.js.map